<template>
  <section>
    <PageHeading title="Relatórios" :pieces="['Relatórios', 'Clientes']" />

    <div style="padding: 20px">
      <v-row style="gap: 8px">
        <v-col sm="6" md="4">
          <date-picker
            placeholder="Selecione o período"
            v-model="period"
            range
            format="DD/MM/YYYY"
            style="width: 100%"
            @clear="period = null"
          ></date-picker>
        </v-col>
        <v-col>
          <v-btn
            :disabled="!period"
            @click="doFilter(period)"
            color="secondary"
            outlined
            elevation="2"
            :loading="isLoading"
            >Filtrar</v-btn
          >
        </v-col>
        <v-col v-show="customers.length" style="justify-content: flex-end; display: flex;">
          <v-btn
            @click="generateExcel"
            color="secondary"
            outlined
            elevation="2"
            :loading="isExporting"
            >Exportar em Excel</v-btn
          >
        </v-col>
      </v-row>
    </div>

    <v-card>
      <v-card-title>
        Clientes
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar..."
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :loading="isLoading"
        loading-text="Carregando... Por favor aguarde"
        :headers="headers"
        :items="customers"
        :search="search"
        :footer-props="{
          'items-per-page-text':'Itens por página',
          'items-per-page-all-text': 'Todos',
          'items-per-page-options': [10, 20, 50, -1]
        }"
      ></v-data-table>
    </v-card>
  </section>
</template>

<script>
import PageHeading from "@/views/admin/components/PageHeading.vue";
import ExportableMixin from '@/mixins/ExportableMixin.js';
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";
import * as firebase from "firebase/app";
import "firebase/firestore";
import { format } from "date-fns";

export default {
  name: "CustomersReport",
  mixins: [ExportableMixin],
  components: { PageHeading, DatePicker },
  methods: {
    async doFilter([startDate, endDate]) {
      this.$data.rawCustomers = [];
      this.$data.customers = [];
      this.$data.isLoading = true;
      startDate.setHours(0);
      startDate.setMinutes(0);
      startDate.setSeconds(0);
      endDate.setHours(23);
      endDate.setMinutes(59);
      endDate.setSeconds(59);
      const customersCollection = firebase.firestore().collection("customers");
      let query = customersCollection
        .where("createdAt", ">=", startDate)
        .where("createdAt", "<=", endDate);

      try {
        (await query.get()).docs.forEach((doc) => {
          const docData = { id: doc.id, ...doc.data() };
          if(docData.geohash) {
            this.$data.rawCustomers.push(docData);
            this.$data.customers.push({
              id: docData.id,
              name: docData.name,
              origin: docData.id[0] === '+' ? 'Whatsapp' : 'Telegram',
              createdAt: format(docData.createdAt.toDate(), "dd/MM/yyyy"),
              fullAddress: `${docData.address} ${docData.address_number}, ${docData.district} - ${docData.city} - ${docData.state}`
            });
          }
        });
      } catch (e) {
        this.$data.errorReason = e;
        alert(`Erro ao buscar os dados. Tente mais tarde.`);
      }

      this.$data.isLoading = false;
    },
    generateExcel() {
      this.$data.isExporting = true;
      const transformedData = [];
      this.$data.rawCustomers.forEach(rawCustomer => {
        const obj = {};
        obj['Número de Whatsapp/Telegram'] = rawCustomer.id;
        obj['Nome'] = rawCustomer.name;
        obj['Endereço'] = rawCustomer.address;
        obj['Número da residencia'] = rawCustomer.address_number;
        obj['Bairro'] = rawCustomer.district;
        obj['Cidade'] = rawCustomer.city;
        obj['Estado'] = rawCustomer.state;
        obj['Complemento'] = rawCustomer.address_complement;
        obj['CEP'] = rawCustomer.zipcode;
        obj['Data de cadastro'] = format(rawCustomer.createdAt.toDate(), "dd/MM/yyyy"),

        transformedData.push(obj);
      });

      this.generateXLS(transformedData);
      this.$data.isExporting = false;
    }
  },
  data() {
    return {
      period: null,
      errorReason: null,
      isLoading: false,
      isExporting: false,
      search: "",
      headers: [
        { text: "Nome", value: "name" },
        { text: "Origem", value: "origin" },
        { text: "Telefone/Telegram", value: "id" },
        { text: "Endreço", value: "fullAddress" },
        { text: "Data de registro", value: "createdAt" }
      ],
      customers: [],
      rawCustomers: []
    };
  },
};
</script>

<style lang="scss">
.v-data-table-header {
  th {
    font-size: 90%;
  }
}

table {
  tr td {
    font-size: 80% !important;
  }
}

.v-data-footer {
  &__select, &__pagination {
    font-size: 1.2rem;
  }
}

.v-data-footer__select .v-select__selections .v-select__selection--comma {
  font-size: 1.2rem;
}
</style>

